export * from './component';



// WEBPACK FOOTER //
// ./src/components/chat-player/index.ts